import { GlobalOutlined, ShopOutlined } from '@ant-design/icons';
import { useGetIdentity } from '@refinedev/core';
import { Tag } from 'antd';
import type { User } from '@/types';
import { getImpersonatedRental } from '@/services/auth';
import { getUserRoleLabel, isAdmin } from '@/types/models';

/**
 * RentalContextIndicator
 *
 * Displays a compact tag in the header showing the current rental context:
 * - Platform admin (Global view): Blue tag "Global view"
 * - Platform admin (Impersonation): nothing, because ImpersonationBanner names the Rental
 * - Manager or Employee: Gray tag with their Rental name and role
 */
export const RentalContextIndicator = (): React.JSX.Element | null => {
  const { data: user } = useGetIdentity<User>();
  const impersonatedRental = getImpersonatedRental();

  if (!user) {
    return null;
  }

  if (isAdmin(user)) {
    if (impersonatedRental) {
      return null;
    }
    return (
      <Tag color="blue" icon={<GlobalOutlined />}>
        Global view
      </Tag>
    );
  }

  // Manager or Employee: show their Rental and role
  if (user.rental) {
    return (
      <Tag icon={<ShopOutlined />}>
        {user.rental.name} · {getUserRoleLabel(user.role)}
      </Tag>
    );
  }

  return null;
};
